var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_vm._v(" "),_c('div',{staticClass:"article_list"},[_c('p',[_vm._v("乐器名称："+_vm._s(_vm.instrument.name))]),_vm._v(" "),_c('img',{attrs:{"src":_vm.instrument.icon,"alt":""}}),_vm._v(" "),_c('p',[_vm._v("乐器Face：")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.instrument.face,"alt":""}})]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41816c3f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/partyTraining/content.vue
// module id = null
// module chunks = 